import { Injectable } from '@angular/core';
import { ApiResponse, VisibaApiHttp } from '../../../../Classes/visibaHttp.class';
import { forkJoin, Observable } from 'rxjs';

export interface ExternalDataModel {
	Origin: string;
	Type: string;
	Data: any;
}

export interface ExternalDataReference {
	guid: string;
	timestamp: number;
}

@Injectable()
export class ExternalDataService {
	readonly baseUri = '/api/Client/v2';

	constructor(private visibaHttp: VisibaApiHttp) {}

	public submitExternalData(externalData: ExternalDataModel[]): Observable<ApiResponse<any>[]> {
		const calls = externalData.map((item) => this.visibaHttp.post(`/api/Client/v2/externaldata`, item));

		return forkJoin(calls);
	}

	public getExternalDataReferences(): ExternalDataReference[] {
		const references: ExternalDataReference[] = JSON.parse(sessionStorage.getItem('externalDataReferences')) || [];

		return references.filter((reference) => this.isGuidValid(reference.timestamp));
	}

	public setGuid(guid: string, time: Date): void {
		const guidData = { guid, timestamp: time.getTime() };
		const externalData = this.getExternalDataReferences();
		externalData.push(guidData);
		sessionStorage.setItem('externalDataReferences', JSON.stringify(externalData));
	}

	public clearExternalDataReferences(): void {
		sessionStorage.removeItem('externalDataReferences');
	}

	private isGuidValid(time: number): boolean {
		const currentDate = new Date();
		const guidDate = new Date(time);
		guidDate.setHours(guidDate.getHours() + 12);

		return guidDate.getTime() >= currentDate.getTime();
	}
}
